import React from 'react'
import { connect } from 'react-redux'
import { Avatar, withStyles } from '@material-ui/core'
import { Person } from '@material-ui/icons'

export default connect(
	(state) => ({
		first: state.addOrEditContact.fields.first_name.value,
		last: state.addOrEditContact.fields.last_name.value,
	}),
	null,
)(
	withStyles((theme) => ({
		avatar: {
			width: 70,
			height: 70,
			fontSize: '3.25rem',
			borderRadius: 15,
			color: '#fff',
			backgroundColor: '#13b940',
		},
		avatarMobile: {
			width: 90,
			height: 90,
			fontSize: '2.5rem',
			borderRadius: 15,
			color: '#fff',
			backgroundColor: '#13b940',
		},
	}))(({ first, last, classes, mobile }) => (
		<Avatar classes={{ root: mobile ? classes.avatarMobile : classes.avatar }}>
			{first || last ? (
				`${first ? first.slice(0, 1) : ''}${last ? last.slice(0, 1) : ''}`
			) : (
				<Person />
			)}
		</Avatar>
	)),
)
